import { render, staticRenderFns } from "./MobileProductCard.vue?vue&type=template&id=a447a38c&scoped=true&"
import script from "./MobileProductCard.vue?vue&type=script&lang=js&"
export * from "./MobileProductCard.vue?vue&type=script&lang=js&"
import style0 from "./MobileProductCard.vue?vue&type=style&index=0&id=a447a38c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a447a38c",
  null
  
)

export default component.exports